import React, { Component } from 'react';
import './styles.scss';

class ErrorScreen extends Component {
  render() {
    let { data } = this.props;
    return (
      <div className="error-container">
        <div className="content">
          <div className="round-bg"><img src={data.img} /></div>
          <div className="error-title-wrapper">{data.header}</div>
          {data.subHeader &&
            <div className="error-sub-wrapper">{data.subHeader}</div>
          }
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default ErrorScreen;